import React from 'react';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { LoadingIndicator } from '@box/blueprint-web';
import css from './loading-form-page.module.scss';
import messages from './messages';

type Props = {
  intl: IntlShape;
};

const LoadingForm = (props: Props) => {
  const { intl } = props;

  return (
    <div className={css.container} data-testid="loading-form-page">
      <LoadingIndicator
        aria-label={intl.formatMessage(messages.loadingIndicatorAriaLabel)}
      />
    </div>
  );
};

export { LoadingForm };
type WrappedProps = Omit<Props, 'intl'>;
const Wrapped = injectIntl(LoadingForm);
export default Wrapped as React.ComponentType<WrappedProps>;
